import produce from 'immer';
import {
  GET_ACTIVE_FILES_REQUEST,
  GET_ACTIVE_FILES_SUCCESS,
  GET_ACTIVE_FILES_FAILURE,
  GET_COVERING_FILES_REQUEST,
  GET_COVERING_FILES_SUCCESS,
  GET_COVERING_FILES_FAILURE,
  GET_CLOSED_FILES_REQUEST,
  GET_CLOSED_FILES_SUCCESS,
  GET_CLOSED_FILES_FAILURE,
  GET_CURRENT_COVERAGE_REQUEST,
  GET_CURRENT_COVERAGE_SUCCESS,
  GET_CURRENT_COVERAGE_FAILURE,
  ASSIGN_COVERAGE_REQUEST,
  ASSIGN_COVERAGE_SUCCESS,
  ASSIGN_COVERAGE_FAILURE,
  UPDATE_COVERAGE_REQUEST,
  UPDATE_COVERAGE_SUCCESS,
  UPDATE_COVERAGE_FAILURE,
  CANCEL_COVERAGE_REQUEST,
  CANCEL_COVERAGE_SUCCESS,
  CANCEL_COVERAGE_FAILURE,
  GET_INTERNAL_USERS_REQUEST,
  GET_INTERNAL_USERS_SUCCESS,
  GET_INTERNAL_USERS_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  DISMISS_NOTIFICATION_REQUEST,
  DISMISS_NOTIFICATION_SUCCESS,
  DISMISS_NOTIFICATION_FAILURE,
  SET_COVERAGE_MODAL_OPEN,
  SET_COVERAGE_MODAL_CLOSED,
  SET_SELECTED_FILES,
  CLEAR_SELECTED_FILES,
} from './myFiles.types';

const initialState = {
  activeFiles: [],
  coveringFiles: [],
  closedFiles: [],
  closedFilesTotalCount: 0,
  currentCoverage: null,
  internalUsers: [],
  notifications: [],
  isLoadingActiveFiles: false,
  isLoadingCoveringFiles: false,
  isLoadingClosedFiles: false,
  isLoadingCoverage: false,
  isLoadingUsers: false,
  isLoadingNotifications: false,
  isCoverageModalOpen: false,
  isEditingCoverage: false,
  existingCoverageData: null,
  selectedFiles: [],
  error: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    default:
      break;
    // Get Active Files
    case GET_ACTIVE_FILES_REQUEST:
      draft.isLoadingActiveFiles = true;
      draft.error = null;
      break;

    case GET_ACTIVE_FILES_SUCCESS:
      draft.activeFiles = action.response || [];
      draft.isLoadingActiveFiles = false;
      break;

    case GET_ACTIVE_FILES_FAILURE:
      draft.isLoadingActiveFiles = false;
      draft.error = action.messages || ['Failed to load active files'];
      break;

    // Get Covering Files
    case GET_COVERING_FILES_REQUEST:
      draft.isLoadingCoveringFiles = true;
      draft.error = null;
      break;

    case GET_COVERING_FILES_SUCCESS:
      draft.coveringFiles = action.response || [];
      draft.isLoadingCoveringFiles = false;
      break;

    case GET_COVERING_FILES_FAILURE:
      draft.isLoadingCoveringFiles = false;
      draft.error = action.messages || ['Failed to load covering files'];
      break;

    // Get Closed Files
    case GET_CLOSED_FILES_REQUEST:
      draft.isLoadingClosedFiles = true;
      draft.error = null;
      break;

    case GET_CLOSED_FILES_SUCCESS:
      draft.closedFiles = action.response || [];
      // Extract total count from first record if available
      draft.closedFilesTotalCount = (action.response && action.response.length > 0)
        ? action.response[0].totalCount
        : 0;
      draft.isLoadingClosedFiles = false;
      break;

    case GET_CLOSED_FILES_FAILURE:
      draft.isLoadingClosedFiles = false;
      draft.error = action.messages || ['Failed to load closed files'];
      break;

    // Get Current Coverage
    case GET_CURRENT_COVERAGE_REQUEST:
      draft.isLoadingCoverage = true;
      draft.error = null;
      break;

    case GET_CURRENT_COVERAGE_SUCCESS:
      draft.currentCoverage = action.response || null;
      draft.isLoadingCoverage = false;
      break;

    case GET_CURRENT_COVERAGE_FAILURE:
      draft.isLoadingCoverage = false;
      draft.error = action.messages || ['Failed to load coverage'];
      break;

    // Assign Coverage
    case ASSIGN_COVERAGE_REQUEST:
      draft.isLoadingCoverage = true;
      draft.error = null;
      break;

    case ASSIGN_COVERAGE_SUCCESS:
      draft.isLoadingCoverage = false;
      draft.isCoverageModalOpen = false;
      draft.selectedFiles = [];
      break;

    case ASSIGN_COVERAGE_FAILURE:
      draft.isLoadingCoverage = false;
      draft.error = action.messages || ['Failed to assign coverage'];
      break;

    // Update Coverage
    case UPDATE_COVERAGE_REQUEST:
      draft.isLoadingCoverage = true;
      draft.error = null;
      break;

    case UPDATE_COVERAGE_SUCCESS:
      draft.isLoadingCoverage = false;
      draft.isCoverageModalOpen = false;
      draft.isEditingCoverage = false;
      draft.existingCoverageData = null;
      draft.selectedFiles = [];
      break;

    case UPDATE_COVERAGE_FAILURE:
      draft.isLoadingCoverage = false;
      draft.error = action.messages || ['Failed to update coverage'];
      break;

    // Cancel Coverage
    case CANCEL_COVERAGE_REQUEST:
      draft.isLoadingCoverage = true;
      draft.error = null;
      break;

    case CANCEL_COVERAGE_SUCCESS:
      draft.isLoadingCoverage = false;
      draft.currentCoverage = null;
      break;

    case CANCEL_COVERAGE_FAILURE:
      draft.isLoadingCoverage = false;
      draft.error = action.messages || ['Failed to cancel coverage'];
      break;

    // Get Internal Users
    case GET_INTERNAL_USERS_REQUEST:
      draft.isLoadingUsers = true;
      break;

    case GET_INTERNAL_USERS_SUCCESS:
      draft.internalUsers = action.response || [];
      draft.isLoadingUsers = false;
      break;

    case GET_INTERNAL_USERS_FAILURE:
      draft.isLoadingUsers = false;
      draft.error = action.messages || ['Failed to load users'];
      break;

    // Get Notifications
    case GET_NOTIFICATIONS_REQUEST:
      draft.isLoadingNotifications = true;
      break;

    case GET_NOTIFICATIONS_SUCCESS:
      draft.notifications = action.response || [];
      draft.isLoadingNotifications = false;
      break;

    case GET_NOTIFICATIONS_FAILURE:
      draft.isLoadingNotifications = false;
      draft.error = action.messages || ['Failed to load notifications'];
      break;

    // Dismiss Notification
    case DISMISS_NOTIFICATION_REQUEST:
      break;

    case DISMISS_NOTIFICATION_SUCCESS:
      // Remove the dismissed notification from the array
      draft.notifications = draft.notifications.filter(
        n => n.userNotificationId !== action.meta?.notificationId
      );
      break;

    case DISMISS_NOTIFICATION_FAILURE:
      draft.error = action.messages || ['Failed to dismiss notification'];
      break;

    // UI State
    case SET_COVERAGE_MODAL_OPEN:
      draft.isCoverageModalOpen = true;
      draft.isEditingCoverage = action.payload?.isEditing || false;
      draft.existingCoverageData = action.payload?.existingCoverage || null;
      break;

    case SET_COVERAGE_MODAL_CLOSED:
      draft.isCoverageModalOpen = false;
      draft.isEditingCoverage = false;
      draft.existingCoverageData = null;
      draft.selectedFiles = [];
      draft.error = null;
      break;

    case SET_SELECTED_FILES:
      draft.selectedFiles = action.payload || [];
      break;

    case CLEAR_SELECTED_FILES:
      draft.selectedFiles = [];
      break;
  }
  return draft;
}, initialState);
